module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB4SURBVEhL7ZRBDoAwCAT7O43/f4H6jwoHTkvD0mpqopPMiV24UX5exSaeYh1Ud6wicIheocddBGw4SnNPdMDmbA5gi2wOiIos8w/cJeCFRgSagyTdB2zO5gC2yOaAqMgy78Djz05frA68QkbdsYhNLJilt/dtSrkAso+vkNK9bKcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bureau/dark/24.png
// module id = 1902
// module chunks = 2